import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { useAllGames } from './useAllGames'
import { LOADER_HANDLER_TYPES } from 'constants/index.js'
import Loader from 'components/ui-kit/Loader/index'
import ContentNotFound from 'components/ui-kit/ContentNotFound/index'
import AllGamesCard from 'components/ui-kit/AllGamesCard/index'
import './AllGames.scss'

const AllGames = memo(({ navRef }) => {
  const { gameCategory, tab, provider, providerName, searchGame, favGame } =
    useSelector((state) => state?.lobby)
  const { favouriteGames, allFavouriteGames } = useSelector(
    (state) => state.games
  )
  const {
    items,
    loading,
    isLoggedIn,
    isFavourite,
    fetchMore,
    favouriteGameHandler,
    fetchMoreFavouriteGames,
    onGamePlayRedirect,
    gameId,
    actionLoading,
    t
  } = useAllGames({ navRef, tab, provider, gameCategory, searchGame })

  const disableLoadMore = favGame
    ? allFavouriteGames?.rows?.length >= allFavouriteGames?.count
    : isFavourite && !favGame
      ? favouriteGames?.rows?.length >= favouriteGames?.count
      : !isFavourite && items?.rows?.length >= items?.count

  return (
    <div className='view-all-page-wrap'>
      <section className='global-casino-section'>
        {gameCategory && (
          <div className='inner-heading'>
            <h4 className='text-uppercase'>{gameCategory}</h4>
          </div>
        )}

        {provider && (
          <div className='inner-heading'>
            <h4 className='text-uppercase'>{providerName}</h4>
          </div>
        )}

        {isFavourite &&
          favGame &&
          (allFavouriteGames?.rows?.length === 0
            ? <ContentNotFound message={t('noMatchesFound')} />
            : (
              <div className='view-all-card-wrap'>
                {allFavouriteGames?.rows?.map((game) => {
                  const item = isFavourite ? game?.CasinoGame : game
                  return (
                    <AllGamesCard
                      key={item?.id}
                      game={game}
                      item={item}
                      onGamePlayRedirect={onGamePlayRedirect}
                      isLoggedIn={isLoggedIn}
                      favouriteGameHandler={favouriteGameHandler}
                      gameId={gameId}
                      actionLoading={actionLoading}
                      isFavourite={isFavourite}
                    />
                  )
                })}
              </div>
              ))}
        {isFavourite &&
          !favGame &&
          (favouriteGames?.rows?.length === 0
            ? <ContentNotFound message={t('noMatchesFound')} />
            : (
              <div className='view-all-card-wrap'>
                {favouriteGames?.rows?.map((game) => {
                  const item = isFavourite ? game?.CasinoGame : game
                  return (
                    <AllGamesCard
                      key={item?.id}
                      game={game}
                      item={item}
                      onGamePlayRedirect={onGamePlayRedirect}
                      isLoggedIn={isLoggedIn}
                      favouriteGameHandler={favouriteGameHandler}
                      gameId={gameId}
                      actionLoading={actionLoading}
                      isFavourite={isFavourite}
                    />
                  )
                })}
              </div>
              ))}
        {!isFavourite &&
          (items?.rows?.length === 0
            ? <ContentNotFound message={t('noMatchesFound')} />
            : (
              <div className='view-all-card-wrap'>
                {items?.rows?.map((game) => {
                  const item = isFavourite ? game?.CasinoGame : game
                  return (
                    <AllGamesCard
                      key={item?.id}
                      game={game}
                      item={item}
                      onGamePlayRedirect={onGamePlayRedirect}
                      isLoggedIn={isLoggedIn}
                      favouriteGameHandler={favouriteGameHandler}
                      gameId={gameId}
                      actionLoading={actionLoading}
                      isFavourite={isFavourite}
                    />
                  )
                })}
              </div>
              ))}
      </section>
      {loading && <Loader variant={LOADER_HANDLER_TYPES.content} />}

      <div
        className={`d-flex justify-content-center align-items-center mt-4 ${
          (favGame
            ? allFavouriteGames?.rows?.length
            : isFavourite && !favGame
            ? favouriteGames?.rows?.length
            : !isFavourite && items?.rows?.length) === 0
            ? 'd-none'
            : ''
        }`}
      >
        <div>
          <button
            className={`btn btn-secondary ${disableLoadMore ? 'd-none' : ''}`}
            disabled={disableLoadMore}
            onClick={() => {
              if (
                favGame &&
                allFavouriteGames?.rows?.length < allFavouriteGames?.count
              ) {
                fetchMoreFavouriteGames()
              } else if (
                isFavourite &&
                !favGame &&
                favouriteGames?.rows?.length < favouriteGames?.count
              ) {
                fetchMoreFavouriteGames()
              } else if (!isFavourite && items?.rows?.length < items?.count) {
                fetchMore()
              }
            }}
          >
            {t('loadMore')}
          </button>
        </div>
      </div>
    </div>
  )
})

export default React.memo(AllGames)
